
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mainStore, leagueStore } from '@/store';
import Edit from './Edit.vue';
import ShowPopup from '@/components/ShowPopup.vue';
import _, { random } from 'lodash';

@Component({
  components: {
    ShowPopup,
    Edit,
  },
})
export default class List extends Vue {
  @Prop({ default: false }) propDashboard;
  public isLoading = false;
  public league_entry = [];
  public grupo_entry = 0;
  public league_status = 'T';
  public propId = 0;
  public propStatus = 0;
  public leagueTaskIdAux = 0;
  public round_league_idAux = '';
  public league_inscritos = [];

  public today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

  get grupoEntry() {
    return [
      {
        id: 1,
        descricao: 'Compacta',
      },
      {
        id: 2,
        descricao: 'Plena',
      },
      {
        id: 3,
        descricao: 'Master',
      },
    ];
  }

  propHeaderLeagueEntry = [
    { text: 'Posição', value: 'index', align: 'center', width: '5%' },
    {
      text: 'Unidade',
      sortable: true,
      value: 'nome_fantasia',
      align: 'left',
    },
    {
      text: 'Pontos',
      sortable: true,
      value: 'pontos',
      align: 'left',
    },
  ];

  headerLeagueEntry = [
    { text: 'Posição', value: 'index', align: 'center', width: '5%' },
    {
      text: 'Unidade',
      sortable: true,
      value: 'nome_fantasia',
      align: 'left',
    },
    {
      text: 'Grupo',
      sortable: true,
      value: 'grupo_nome',
      align: 'left',
    },
    {
      text: 'Pontos',
      sortable: true,
      value: 'pontos',
      align: 'left',
    },
  ];

  get currentUser() {
    return mainStore.userProfile;
  }

  get allItems() {
    let item = this.league_entry;
    if (this.grupo_entry > 0) {
      item = item.filter((f) => f.grupo === this.grupo_entry);
      if (this.propDashboard) {
        return item.slice(0, 10);
      }
    }

    return item;
  }

  public async handleConferirProva(company_id) {
    const companyidString = company_id.toString();
    this.$router.push({
      name: 'main-league-entry-conferir-matriculas-unidade',
      params: {
        cid: companyidString,
        id: String(this.leagueTaskIdAux),
        etid: this.round_league_idAux,
      },
    });
  }

  public async mounted() {
    this.isLoading = true;
    let league_id = 2;
    this.league_entry = await leagueStore.getLeagueEntryRanking(league_id);
    if (this.currentUser.company_id === 1) {
      this.grupo_entry = 3;
    } else {
      this.league_inscritos = await leagueStore.getLeagueEntryAll(league_id);
      let list = this.league_inscritos.find((item) => item.company_id === this.currentUser.company_id);
      this.grupo_entry = list.grupo;
    }
    this.isLoading = false;
  }
}
